export const getPopUpBrowserEventForConfirmation = () => {
  return {
    event: 'popUpBrowser',
    eventCategory: 'Popup',
    eventAction: 'Browser support',
    eventLabel: 'Click | More Information',
  }
}

export const getPopUpBrowserEventForClosing = () => {
  return {
    event: 'popUpBrowser',
    eventCategory: 'Popup',
    eventAction: 'Browser support',
    eventLabel: 'Click | Close',
  }
}

export const getPopUpBrowserEventForImpression = () => {
  return {
    event: 'popUpBrowser',
    eventCategory: 'Popup',
    eventAction: 'Browser support',
    eventLabel: 'Impression',
  }
}
